// extracted by mini-css-extract-plugin
export var quantityInput = "_ow-0";